export default __webpack_public_path__ + "static/media/loss.2f34b0aa.svg";